import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { read } from 'fs';
import { DataApiService } from 'src/app/Services/data-api.service';
import { AlertRefreshComponent } from '../alert-refresh/alert-refresh.component';
import {FileUploadService} from './../../../Services/file-upload.service';

export interface DialogData2 {
  id_pedido: string;  
}
@Component({
  selector: 'app-editar-servicio-por-motorizado',
  templateUrl: './editar-servicio-por-motorizado.component.html',
  styleUrls: ['./editar-servicio-por-motorizado.component.scss']
})
export class EditarServicioPorMotorizadoComponent implements OnInit {

  constructor(
    private fileUploadService: FileUploadService,
    private dataApi:DataApiService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EditarServicioPorMotorizadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData2
  ) { }

  public formularioCambiarEstado={
    id_pedido :this.data,
    estado:null,
    file:null,
    file_name:null,
    base64textString:null,
    obs_devolucion:null,
    type:"constancia"
  }
  errorFile = null;
  errorSize= null;
  saveImage:any = null;

  cambiarPedidoEstado(){
    if( this.formularioCambiarEstado.estado==2 &&  this.formularioCambiarEstado.file==null ){
      this.errorFile="Por favor escoger la foto de cargo.";
    }else if( this.formularioCambiarEstado.estado==2 && this.formularioCambiarEstado.file=="" ){
      this.errorFile="Por favor escoger la foto de cargo.";
    }else if(
      this.formularioCambiarEstado.estado!=2  && this.formularioCambiarEstado.file!=null
    ){
      this.errorFile="El estado seleccionado es incorrecto.";
    }else{
      this.errorFile = null;
      this.dataApi.cambiarPedidoEstadoDesdeMotorizado(this.formularioCambiarEstado).subscribe(
        data=>this.handleResponse(data),
        error =>this.handleError(error)
      ) 
      if(
          this.formularioCambiarEstado.file!=null && 
          this.formularioCambiarEstado.file_name!=null && 
          this.formularioCambiarEstado.base64textString!=null
      ){        
        this.fileUploadService.postFileImagen(this.saveImage,this.formularioCambiarEstado.id_pedido,this.formularioCambiarEstado.type).subscribe(
          data=>console.log(data)
        )
      }
      
    }    
  }
  handleResponse(data){    
    const message = data.estado==2 ? "El servicio ha sido finalizado con éxito" : "Has procesado el servicio con éxito";
    this.dialog.closeAll(); 
    this.dialog.open(AlertRefreshComponent,{
      width:"200px",   
      data:{mensaje:message},
      disableClose: false,
      autoFocus:true
    }); 
  }
  handleError(error){
    console.log(error)
  }
  cerrarForm(){
    this.dialogRef.close();
  }
  filePreview(input){
    const files = input.files;
    const file = files[0];
    const size = Number((file.size/1024)/1024);

    if(files && file && size<=1  ){
      this.errorSize=null;
      const reader = new FileReader();
      reader.onload = (event)=>{
        document.getElementById("filePreview").innerHTML = `<img src="${event.target["result"]}" style="width:100%"/>`;
      }
      reader.readAsDataURL(input.files[0]);
    }else{
      document.getElementById("filePreview").innerHTML ="";
      this.errorSize="La foto de cargo excede lo permitido, bajar la resolucion de la cámara.";
      this.formularioCambiarEstado.file="";
      console.log( this.formularioCambiarEstado.file )
    }
  }
  seleccionarArchivo(event){
   
    const files = event.target.files;
    const file = files[0];
    const size = Number((file.size/1024)/1024);

    this.saveImage = file;   
    
    if(files && file && size<=1 ){
      this.formularioCambiarEstado.file_name = "pedido-"+ this.formularioCambiarEstado.id_pedido +"-"+ file.name;
      var reader = new FileReader();
      reader.onload= this._handleReaderLoadad.bind(this);      
      
      reader.readAsBinaryString(file)
    }
  }
  _handleReaderLoadad(readerEvent){
    const binaryString = readerEvent.target.result;
    
    this.formularioCambiarEstado.base64textString = btoa(binaryString)
  }  

  ngOnInit() {
    const file = document.getElementById("file");
    file.addEventListener("change",()=>{
    this.filePreview(file);
   })
  }

}
